export class TypeQuantite {
    atq_id: number;
    atq_abreviation: string;
    atq_libelle: string;

    constructor(init: Partial<TypeQuantite>) {
        for (let prop in init) {
            this[prop] = init[prop];
        }
    }

    toJSON() {
        const type: any = {};
        Object.assign(type, this);
        return JSON.stringify(type);
    }
}